'use client';

import EntryRevalidator from '@/components/EntryRevalidator';
import GridLayout, { type GridLayoutProps } from '../GridLayout';
import type { Revalidation } from './revalidation';

export default function RevalidatedGridLayout({
  uri,
  revalidate = true,
  entry,
  ...props
}: GridLayoutProps & Revalidation) {
  return (
    <EntryRevalidator {...{ uri, entry, enabled: revalidate }}>
      {(fresh) => <GridLayout {...props} entry={fresh} />}
    </EntryRevalidator>
  );
}
